/**
 * @generated SignedSource<<6133c4eebc7fa79b30eb6413b0907c7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_viewer$data = {
  readonly isDyoEnabled: boolean | null;
  readonly " $fragmentType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$key = {
  readonly " $data"?: PdpRespSidebarButtons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bf4d71a2fa60982a3c7e5728abadae8b";

export default node;
